import React, { useState } from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRouting } from '~/routing/useRouting';
import fieldEmailLogoSrc from '~/ui/assets/icons/field-email.svg';
import Card from '~/ui/components/Card/index';
import CardList from '~/ui/components/CardList/CardList';

import IntegrationDetailCard from '../IntegrationDetailCard';

function EmailIntegrations() {
  const { navigate, params } = useRouting();
  const intl = useIntl();

  const [isCollapsed, setIsCollapsed] = useState(true);

  const footerActionButtons = (
    <Button
      text={intl.formatMessage({
        id: 'EmailIntegrations.closeButton',
        defaultMessage: 'Close',
        description: 'Close button text',
      })}
      variant="tertiary"
      onClick={() => setIsCollapsed(true)}
    />
  );

  const headerRightContent = (
    <Button
      text={intl.formatMessage({
        id: 'EmailIntegrations.goToEmailIntakeButton',
        defaultMessage: 'Go to Email Intake',
        description: 'Button to navigate to email intake page',
      })}
      variant="action"
      onClick={() => {
        navigate(`/admin/console/${params.clientId}/email-intake`);
      }}
    />
  );

  return (
    <CardList
      title={intl.formatMessage({
        id: 'EmailIntegrations.emailTitle',
        defaultMessage: 'Email',
        description: 'Email integrations section title',
      })}
    >
      <IntegrationDetailCard
        footer={<Card.Footer actionButtons={footerActionButtons} />}
        headerRightContent={headerRightContent}
        isCollapsed={isCollapsed}
        logoSrc={fieldEmailLogoSrc}
        title={intl.formatMessage({
          id: 'EmailIntegrations.emailIntakeTitle',
          defaultMessage: 'Email Intake',
          description: 'Email intake integration card title',
        })}
        onToggleCollapse={setIsCollapsed}
      >
        <FormattedMessage
          id="EmailIntegrations.emailIntakeDescription"
          defaultMessage="Forward emails to the platform containing contracts you want uploaded into Evisort"
          description="Description of email intake functionality"
        />
      </IntegrationDetailCard>
    </CardList>
  );
}

export default EmailIntegrations;
